<template lang="pug">
span.text-body-2
  span(v-if="data.prefix") {{ data.prefix + " " }}
  a.a(
    v-if="data.biblio"
    :href="href"
    target="_blank"
    v-html="data.rendered"
  )
  // If both the rendered citation and the biblio number is missing, show (Missing citation).
  span(
    v-else
    v-html="data.rendered || '(Missing citation)'"
  )
  span(v-if="data.pages") {{ ` p. ${data.pages}.` }}
  // Hide error behind an icon, since it's not useful to most users.
  VIcon(
    v-if="data.error"
    :title="data.error"
    size="small"
    color="warning"
  ) {{ mdiAlert }}
</template>

<script setup lang="ts">
import { mdiAlert } from "@mdi/js";
import type { KohaMentionItem } from "./commentNodeKoha.types";

interface Props {
  data: KohaMentionItem;
}

const props = withDefaults(defineProps<Props>(), {});

const href = computed<string | undefined>(() => {
  if (!props.data.biblio) {
    return undefined;
  }
  return `https://library.refstudycentre.com/cgi-bin/koha/opac-detail.pl?biblionumber=${props.data.biblio}`;
});
</script>
